import React from "react";
export const WordContext = React.createContext({
    isTrackChangesEnabled: false
});
const refEquality = (a, b)=>a === b;
export function useWordContext(selector, equalityFn = refEquality) {
    const state = React.useContext(WordContext);
    if (state === null) {
        throw new Error("useWordContext must be used within an WordContextProvider");
    }
    const selectedState = selector(state);
    const selectedStateRef = React.useRef(selectedState);
    const latestSelectedState = selectedStateRef.current;
    if (!equalityFn(latestSelectedState, selectedState)) {
        selectedStateRef.current = selectedState;
    }
    return selectedStateRef.current;
}
